import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { SelectionItem } from '../../../core/component/select/select.component';

@Injectable()
export class CountryService {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = config.apiEndpointV2;
  }

  private _endpoint: string;
  get(): Observable<SelectionItem[]> {
    return this._client.get<SelectionItem[]>(this._endpoint + '/country');
  }
}
